import { Injectable, NgZone } from "@angular/core";
import * as AWS from "aws-sdk";
import { environment } from "../../environments/environment";
import { Config } from "../_store/config";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs";

export interface UploadProgress {
  loaded: number;
  total: number;
  percentage: number;
}

export interface UploadResult {
  key: string;
  url: string;
  success: boolean;
  error?: string;
}

@Injectable({
  providedIn: "root",
})
export class S3Service {
  private s3: AWS.S3;

  constructor(private ngZone: NgZone, private http: HttpClient) {
    // this.initializeS3Client();
  }



  /**
   * Upload a file to S3
   * @param file - The file to upload
   * @param folder - Optional folder path (default: 'uploads')
   * @param progressCallback - Optional callback for upload progress
   * @returns Promise<UploadResult>
   */
  // async uploadFile(file: File, folder: string = "uploads", sellerName: string, buyerName: string, progressCallback?: (progress: UploadProgress) => void): Promise<UploadResult> {
  //   if (!file) {
  //     throw new Error("No file provided");
  //   }

  //   try {
  //     const key = `${folder}/${Date.now()}-${sellerName}-${buyerName}-${file.name}`;

  //     const uploadParams = {
  //       Bucket: (window as any).overrideEnvironment.s3.bucket,
  //       Key: key,
  //       Body: file,
  //       ContentType: file.type,
  //     };

  //     // Upload file
  //     const result = await this.s3.upload(uploadParams).promise();

  //     // Generate a signed URL for the uploaded file
  //     const url = this.s3.getSignedUrl("getObject", {
  //       Bucket: (window as any).overrideEnvironment.s3.bucket,
  //       Key: key,
  //       Expires: 3600,
  //     });

  //     return {
  //       key: key,
  //       url: url,
  //       success: true,
  //     };
  //   } catch (error) {
  //     console.error("S3 upload error:", error);

  //     return {
  //       key: "",
  //       url: "",
  //       success: false,
  //       error: this.getErrorMessage(error),
  //     };
  //   }
  // }

  /**
   * Get a signed URL for a file in S3 (via API).
   * @param key - The S3 key of the file
   */
  getFile(key) {
    console.log(key, "key");

    const payload = {
      fileKey: `${key}`,
      product: "jsw",
    };
    return this.http.post(Config.urls.GET_SIGNED_URL, payload)
    
  }

}
